import { render, staticRenderFns } from "./DialogoBuilderRelatorio.vue?vue&type=template&id=7f82c4c1&scoped=true&"
import script from "./DialogoBuilderRelatorio.vue?vue&type=script&lang=ts&"
export * from "./DialogoBuilderRelatorio.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoBuilderRelatorio.vue?vue&type=style&index=0&id=7f82c4c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f82c4c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VCard,VCheckbox,VChip,VDialog,VIcon,VSelect,VTextField,VTooltip})
